import { Modal } from 'react-bootstrap'

import { Tarea } from '../models'

type Props = {
  tarea?: Tarea
  isModoEditar: boolean
  close: () => void
}

export const ModalTareaHeader = ({ tarea, isModoEditar,close }: Props) => {
  return (
    <Modal.Header>
      <div className='align-items-center d-flex flex-grow-1 '>
        <h3 className='modal-tittle'>{isModoEditar ? 'Editar tarea' : 'Nueva tarea'}</h3>
        <span className='text-muted fw-lighter fs-4 ps-2 d-flex'>
          {isModoEditar && ` | ${tarea?.titulo}`}
        </span>
      </div>
      {/* Cierre explícito (backdrop es static en el contenedor). */}
      <button
        onClick={close}
        className=' close btn  btn-outline-dark btn-icon btn-circle btn-sm ms-5 d-flex col-12 '>
        <i className='fa-solid fa-plus fs-1' style={{ rotate: '45deg' }}></i>
      </button>
    </Modal.Header>
  )
}
